import styled from 'styled-components';
import {
  Add16Regular as AddIcon,
  Add20Regular as AddIconLarge,
} from '@fluentui/react-icons';
import {
  PopoverSurface,
  Button,
  MenuItem,
  Textarea,
  Badge,
} from '@fluentui/react-components';
import { isMobile } from 'react-device-detect';
import { colorPallet } from 'src/styles/theme/colors';

export const GoalCardContainer = styled.div<{
  visible: boolean;
  overlay: boolean;
  hasInput: boolean;
  position: number;
  isMobile?: boolean;
}>`
  transition: all 0.3s ease-out;
  visibility: ${({ visible }) => (visible ? 'visible' : 'hidden')};
  display: ${({ visible }) => (visible ? 'flex' : 'hidden')};
  width: ${({ visible }) => (visible ? '100%' : '85%')};
  height: ${({ visible }) => (visible ? 'auto' : '0')};
  padding: ${({ visible }) => (visible ? '16px' : '0')};
  margin-top: ${({ visible }) => (!visible ? '-8px' : '0')};
  button {
    visibility: ${({ visible }) => (visible ? 'visible' : 'hidden')};
  }
  border-radius: 4px;
  flex-direction: column;
  gap: 10px;
  background: ${({ theme }) => theme.goalsCardBackground};
  box-shadow:
    0 0.8px 1.8px rgba(0, 0, 0, 0.13),
    0 0.15px 0.45px rgba(0, 0, 0, 0.11);
  position: ${({ hasInput }) => (hasInput && isMobile ? 'fixed' : 'relative')};
  margin-bottom: ${({ position, hasInput }) =>
    hasInput && isMobile ? `${position}px` : '0'};
  z-index: ${({ overlay, isMobile, hasInput }) =>
    !isMobile ? (overlay ? 1 : 0) : hasInput ? '9999' : 'auto'};
  right: ${({ hasInput }) => (hasInput && isMobile ? '0' : 'auto')};
  bottom: ${({ hasInput }) => (hasInput && isMobile ? '0' : 'auto')};
`;

export const GoalCardDescription = styled.p`
  font-size: 16px;
  font-weight: 400;
  line-height: 22px;
  color: #242424;
  word-break: break-word;
  color: ${({ theme }) => theme.goalsCardText};
`;

export const CoalBadge = styled(Badge)<{
  badgeColor?: string;
}>`
  cursor: ${({ badgeColor }) =>
    badgeColor === 'ghost' ? 'pointer' : 'default'};
`;

export const GoalCardBottomContainer = styled.div`
  display: flex;
  justify-content: space-between;
  svg {
    cursor: pointer;
  }
`;

export const MoreButtonContainer = styled.div`
  display: flex;
  width: 100%;
  align-items: flex-end;
  justify-content: flex-end;
`;

export const CancellIcon = styled(AddIcon)`
  transform: rotate(45deg);
`;

export const CancellIconLarge = styled(AddIconLarge)`
  transform: rotate(45deg);
`;

export const GoalCardTextarea = styled(Textarea).attrs({
  appearance: 'filled-darker',
})<{
  shown?: boolean;
}>`
  margin-top: -5px;
  transition: all 0.3s ease-in;
  font-size: ${() => (isMobile ? '16px' : '14px')};
  font-weight: 400;
  background-color: ${({ theme }) => theme.goalsTextareaBackground};
  @media (max-width: 768px) {
    font-size: 16px;
    textarea {
      font-size: 16px;
    }
  }

  textarea {
    max-height: 320px;
  }
`;

export const DiscardButton = styled(Button)`
  min-width: 72px;
  width: 72px;
  padding-left: 12px;
  padding-right: 12px;
  margin-right: 10px;
`;

export const GoalPopoverSurface = styled(PopoverSurface)<{
  isMobile?: boolean;
}>`
  display: flex;
  width: 160px;
  padding: 4px;
  gap: 2px;
  flex-direction: column;

  ${({ isMobile }) =>
    isMobile &&
    `
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    width: 100%;
  `}
  h1 {
    padding-left: 8px;
    text-align: left;
    font-size: 12px;
    line-height: 16px;
    font-weight: 600;
    color: ${({ theme }) => theme.goalsCardCommentText};
    min-height: 32px;
    display: flex;
    align-items: center;
  }
`;

export const GoalMenuItem = styled(MenuItem)<{ isMobile?: boolean }>`
  font-size: 14px;
  line-height: 20px;
  font-weight: 400;
  color: ${({ theme }) => theme.goalsMenuItemColor};
  ${({ isMobile }) =>
    isMobile &&
    `
   max-width: 100%;
  `}
`;

export const GoalProgressCommentLabel = styled.p`
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  color: ${({ theme }) => theme.goalsCardCommentLabel};
`;

export const GoalProgressComment = styled.p`
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  padding-top: 4px;
  word-break: break-word;
  color: ${({ theme }) => theme.goalsCardCommentText};
`;

export const MobileActionsContainer = styled.div`
  display: flex;
  justify-content: space-between;
  h1 {
    font-size: 18px;
    font-weight: 700;
  }
  p {
    font-size: 14px;
    font-weight: 600;
    color: ${colorPallet.richBlue};
  }
`;
